import {useState, useContext, useEffect} from "react";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import {faQuestion} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";


import AuthContext from "context/AuthContext";
import axiApi from "ApiCaller";
import useCustomTranslation from "core/customTranslation";

const translations = {
    "es": {
        "history": "Historial de cambios",
        "docs": "Documentación",
    },
    "en": {
        "history": "History of changes",
        "docs": "Documentation",
    },
};

const NavQuestion = () => {
    const {t: _TC} = useCustomTranslation(translations);
    const [show, setShow] = useState(false);
    const {org} = useContext(AuthContext);
    const currentDomain = window.location.hostname;
    const isOrionaiot = currentDomain.toLowerCase().includes("orionaiot");
    const [latestVersion, setLatestVersion] = useState(null);
    const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
    const appVersion = process.env.REACT_APP_VERSION || "dev";

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const fetchLatestVersion = async () => {
            try {
                const response = await axiApi.get("/api/loggers/releases/");
                if (response.status === 200) {
                    setLatestVersion(response.data?.[0]?.version);
                } else {
                    console.error("error:", response);
                }
            } catch (error) {
                console.error("error:", error);
            }
        };

        fetchLatestVersion();
    }, []);

    return (
        <>
            <Nav.Link onClick={handleShow} className="ps-1 pe-1">
                <FontAwesomeIcon icon={faQuestion} />
            </Nav.Link>

            <Modal show={show} onHide={handleClose} centered size="sm">
                <Modal.Body className="text-center">
                    <div className="mb-5 mt-2">
                        <img
                            src={urlStatic + (isOrionaiot ? "/images/logo-orionaiot-purple.svg" : "/images/quamtra_manager-black.svg")}
                            height="30"
                            className="d-inline-block align-top"
                            alt={org.name ? "logo " + org.name : "Logo organization"}
                        />
                    </div>

                    {latestVersion && (
                        <Link
                            to={`/releases/${latestVersion}/`}
                            className="text-muted text-decoration-none"
                            onClick={handleClose}>
                            Versión: <strong>{latestVersion}</strong>
                        </Link>
                    )}

                    <h5 className="text-left mt-3">
                        <Link to="/releases/" className="text-decoration-none text-dark" onClick={handleClose}>
                            {_TC("history")}
                        </Link>
                    </h5>

                    <h5 className="text-left mt-3">
                        <Link to="/documentation/" className="text-decoration-none text-dark" onClick={handleClose}>
                            {_TC("docs")}
                        </Link>
                    </h5>

                    <div className="mt-4 mb-2 text-muted" style={{fontSize: "0.8rem"}}>
                        © {new Date().getFullYear()}{" "}
                        {isOrionaiot ? (
                            <a href="https://orionaiot.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                OrionAiot
                            </a>
                        ) : (
                            <a href="https://sol-x.es/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                Sol-X Smart Technology
                            </a>
                        )}
                    </div>
                    <div className="text-white">{appVersion}</div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default NavQuestion;
